import Vue from 'vue';
export default {
  getOrderList (params) {
    return Vue.axios.get('/rx/user/api/v2.0/loan/application/list', { params });
  },
  getOrderDetails (params) {
    return Vue.axios.get('/rx/user/api/v1.0/loan/application/detail', { params });
  }
};
